import { all, takeLatest, put, select, call } from 'redux-saga/effects';

import {
  apiGetDeleteAccountReason,
  apiDeleteAccount,
} from '@dragonfruit/services/apis';
import {
  actions,
  types,
  getDeleteAccountReasonId,
  getDeleteAccountDetailId,
  getUserReason,
} from '@dragonfruit/redux/deleteAccount';
import { getRole, getLoginType } from '@dragonfruit/redux/profile';
import { logout } from '@dragonfruit/redux/auth';
import { FACEBOOK_AUTH_TYPE } from '@dragonfruit/constants/authType';
import { home, confirmDeleteAccount } from '../redux/navigation';
import { showAlertBanner } from '@dragonfruit/redux/alertBanner';
import { ALERT_ERROR_THEME } from '@dragonfruit/constants/alertBannerThemes';
import * as facebookSDK from '@dragonfruit/services/facebookSDK';

const FACEBOOK_CONNECTED = 'connected';

export function* getDeleteAccountReasonFlow() {
  try {
    const userRole = yield select(getRole);
    const response = yield call(apiGetDeleteAccountReason, userRole);
    const { data: reasons } = response;
    yield put(actions.getDeleteAccountReasonSuccess({ reasons }));
  } catch (error) {
    yield put(actions.getDeleteAccountReasonFailure(error.message));
  }
}

/* eslint-disable consistent-return */
function* checkFacebookLogin() {
  // check facebook login status
  const response = yield call(facebookSDK.checkLoginStatus);

  if (response.status === FACEBOOK_CONNECTED) {
    const { status, authResponse } = response;

    if (authResponse && status === FACEBOOK_CONNECTED) {
      const { userID, accessToken } = authResponse;

      return {
        userID,
        accessToken,
      };
    }
  } else {
    // prompt facebook login frame.
    const facebookLoginResponse = yield call(facebookSDK.facebookLogin);

    const { status, authResponse } = facebookLoginResponse;

    if (authResponse && status === FACEBOOK_CONNECTED) {
      const { userID, accessToken } = authResponse;

      return {
        userID,
        accessToken,
      };
    }
  }
}

export function* deleteAccountFlow(action) {
  const { password } = action;

  const signupType = yield select(getLoginType);
  /*eslint-disable camelcase */
  const delete_account_reason_id = yield select(getDeleteAccountReasonId);
  const delete_account_reason_detail_id = yield select(
    getDeleteAccountDetailId
  );
  const delete_account_description = yield select(getUserReason);

  // TODO prpare post data
  const data = {
    delete_account_reason_id,
    delete_account_reason_detail_id,
    delete_account_description,
  };

  // TODO third-party handling
  if (signupType === FACEBOOK_AUTH_TYPE) {
    const { userID: provider_uid, accessToken: provider_token } = yield call(
      checkFacebookLogin
    );
    data.provider = FACEBOOK_AUTH_TYPE;
    data.provider_uid = provider_uid;
    data.provider_token = provider_token;
  } else {
    if (password) {
      data.password = password;
    }
  }

  try {
    yield call(apiDeleteAccount, data);
    yield put(actions.deleteAccountSuccess());
    yield put(home());
    yield put(logout());
  } catch (error) {
    yield put(actions.deleteAccountFailure(error.message));
    yield put(
      showAlertBanner({
        message: error.message,
        theme: ALERT_ERROR_THEME,
      })
    );
  }
}

export function* submitDeleteAccountFlow() {
  yield put(confirmDeleteAccount());
}

export default function*() {
  yield all([
    takeLatest(
      types.GET_DELETE_ACCOUNT_REASON_REQUEST,
      getDeleteAccountReasonFlow
    ),
    takeLatest(types.DELETE_ACCOUNT_REQUEST, deleteAccountFlow),
    takeLatest(types.SUBMIT_DELETE_REASON, submitDeleteAccountFlow),
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/deleteAccount.js